import styled, { css } from 'styled-components';

const CHECK_STYLES = {
  light: css`
    ${({ theme }) => css`
      color: ${theme.palette.primary.main};
      background-color: ${theme.palette.neutral[100]};
      border-color: ${theme.palette.neutral[300]};

      &[data-error='true'] {
        color: ${theme.palette.error.main};
      }

      &[data-state='checked'] {
        background-color: ${theme.palette.primary.main};
        border-color: ${theme.palette.primary.main};
        color: ${theme.palette.text.white};

        &[data-error='true'] {
          background-color: ${theme.palette.error.main};
          border-color: ${theme.palette.error.main};
        }
      }
    `}
  `,
  dark: css`
    ${({ theme }) => css`
      color: ${theme.palette.primary.main};
      background-color: ${theme.palette.neutral[100]};
      border-color: ${theme.palette.neutral[100]};

      &[data-error='true'] {
        color: ${theme.palette.error.main};
      }

      &[data-state='checked'] {
        border-color: ${theme.palette.primary.main};

        &[data-error='true'] {
          border-color: ${theme.palette.error.main};
        }
      }
    `}
  `,
};

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 1rem;

    label {
      cursor: pointer;
      font-size: ${theme.typography.sizes.body1};
      width: fit-content;
    }

    > ul {
      display: flex;
      gap: 2rem;
      align-items: center;

      li {
        display: flex;
        gap: 1rem;
        align-items: center;

        > button {
          height: 1.5rem;
          width: 1.5rem;
          border-radius: 0.5rem;
          flex-shrink: 0;

          cursor: pointer;

          display: flex;
          align-items: center;
          justify-content: center;

          border: 1px solid ${theme.palette.neutral[100]};
          transition: border-color 0.2s, color 0.2s;

          span {
            display: flex;
            align-items: center;
            justify-content: center;
          }

          ${CHECK_STYLES[theme.name]}
        }

        label {
          cursor: pointer;
        }
      }
    }

    > span {
      color: ${theme.palette.error.main};
      font-size: ${theme.typography.sizes.caption};
    }
  `}
`;
